import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const VimeoBase = styled.div`
  margin: ${theme.spacing[8]} auto;
  padding: 56.25% 0 0 0;
  position: relative;

  iframe {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
`;
